/* unplugin-vue-components disabled */import { render } from "./PrivacyPolicys.vue?vue&type=template&id=05c94648&scoped=true"
import script from "./PrivacyPolicys.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicys.vue?vue&type=script&lang=js"

import "./PrivacyPolicys.vue?vue&type=style&index=0&id=05c94648&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/quan-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05c94648"]])

export default __exports__